import IMaterialItemMaster from "../../interfaces/masters/material-item-master-interface";

/**
 * id   5桁の0埋めUID
 * name 画像名
 * code icomoonで生成したfontcssを読み込む
 *
 * NOTE: 種別が増えるならtypeを持たせるかマスタ分けるかなど考慮が必要
 */
export const decoItemMasterRecords: IMaterialItemMaster[] = [
  {
    id: "00001",
    name: "fundou",
    code: "\ue900",
  },
  {
    id: "00002",
    name: "agarifuji",
    code: "\ue901",
  },
  {
    id: "00003",
    name: "akadori",
    code: "\ue902",
  },
  {
    id: "00004",
    name: "aoi",
    code: "\ue903",
  },
  {
    id: "00005",
    name: "asanoha",
    code: "\ue904",
  },
  {
    id: "00006",
    name: "asanohana",
    code: "\ue905",
  },
  {
    id: "00007",
    name: "chanomi",
    code: "\ue906",
  },
  {
    id: "00008",
    name: "chigai-tare-kaku",
    code: "\ue907",
  },
  {
    id: "00009",
    name: "chu-hira-kaku",
    code: "\ue908",
  },
  /* なぜかマルチカラーフォント扱いになっており表示に問題が生じているので、一旦コメントアウト
  {
    id: "00010",
    name: "daki-myoga",
    code: "\ue909",
  },
  */
  {
    id: "00011",
    name: "dakiine",
    code: "\ue927",
  },
  {
    id: "00012",
    name: "futatsudomoe",
    code: "\ue928",
  },
  {
    id: "00013",
    name: "genjiwa",
    code: "\ue929",
  },
  {
    id: "00014",
    name: "gohonhone-ohgi",
    code: "\ue92a",
  },
  {
    id: "00015",
    name: "goka",
    code: "\ue92b",
  },
  {
    id: "00016",
    name: "goshichigiri",
    code: "\ue92c",
  },
  {
    id: "00017",
    name: "hagoita",
    code: "\ue92d",
  },
  {
    id: "00018",
    name: "hana-thsurumusubi",
    code: "\ue92e",
  },
  {
    id: "00019",
    name: "hanabishi",
    code: "\ue92f",
  },
  {
    id: "00020",
    name: "hanagata-kaku",
    code: "\ue930",
  },
  {
    id: "00021",
    name: "heishi",
    code: "\ue931",
  },
  {
    id: "00022",
    name: "hiiragi",
    code: "\ue932",
  },
  {
    id: "00023",
    name: "hira-sumikiri-kaku",
    code: "\ue933",
  },
  {
    id: "00024",
    name: "hishikaede",
    code: "\ue934",
  },
  {
    id: "00025",
    name: "ichimonji",
    code: "\ue935",
  },
  {
    id: "00026",
    name: "igeta",
    code: "\ue936",
  },
  {
    id: "00027",
    name: "ikari",
    code: "\ue937",
  },
  {
    id: "00028",
    name: "ishida-mitsunari",
    code: "\ue938",
  },
  {
    id: "00029",
    name: "itsutsuityou",
    code: "\ue939",
  },
  {
    id: "00030",
    name: "ityou",
    code: "\ue93a",
  },
  {
    id: "00031",
    name: "jigami",
    code: "\ue93b",
  },
  {
    id: "00032",
    name: "kajinoha",
    code: "\ue93c",
  },
  {
    id: "00033",
    name: "karigane",
    code: "\ue93d",
  },
  {
    id: "00034",
    name: "kasa",
    code: "\ue93e",
  },
  {
    id: "00035",
    name: "kashiwa",
    code: "\ue93f",
  },
  {
    id: "00036",
    name: "katabami",
    code: "\ue940",
  },
  {
    id: "00037",
    name: "kiku",
    code: "\ue941",
  },
  {
    id: "00038",
    name: "kikyou",
    code: "\ue942",
  },
  {
    id: "00039",
    name: "kinoji",
    code: "\ue943",
  },
  {
    id: "00040",
    name: "kumiai-kaku",
    code: "\ue944",
  },
  {
    id: "00041",
    name: "mamukiho",
    code: "\ue945",
  },
  {
    id: "00042",
    name: "manji",
    code: "\ue946",
  },
  {
    id: "00043",
    name: "maribasami",
    code: "\ue947",
  },
  {
    id: "00044",
    name: "maru",
    code: "\ue948",
  },
  {
    id: "00045",
    name: "mikumi-kaku",
    code: "\ue949",
  },
  {
    id: "00046",
    name: "mokkou",
    code: "\ue94a",
  },
  {
    id: "00047",
    name: "mumoji",
    code: "\ue94b",
  },
  {
    id: "00048",
    name: "nadeshiko",
    code: "\ue94c",
  },
  {
    id: "00049",
    name: "nakairi-kaku",
    code: "\ue94d",
  },
  {
    id: "00050",
    name: "noshiwa",
    code: "\ue94e",
  },
  {
    id: "00051",
    name: "ohgi",
    code: "\ue94f",
  },
  {
    id: "00052",
    name: "rikko",
    code: "\ue950",
  },
  {
    id: "00053",
    name: "rokkaku",
    code: "\ue951",
  },
  {
    id: "00054",
    name: "sakura",
    code: "\ue952",
  },
  {
    id: "00055",
    name: "sankakumatsu",
    code: "\ue953",
  },
  {
    id: "00056",
    name: "sasarindou",
    code: "\ue954",
  },
  {
    id: "00057",
    name: "shamidou-kaku",
    code: "\ue955",
  },
  {
    id: "00058",
    name: "shuro",
    code: "\ue956",
  },
  {
    id: "00059",
    name: "shurokaku",
    code: "\ue957",
  },
  {
    id: "00060",
    name: "sumidate-kaku",
    code: "\ue958",
  },
  {
    id: "00061",
    name: "sumikiri-kaku",
    code: "\ue959",
  },
  {
    id: "00062",
    name: "syamigoma",
    code: "\ue95a",
  },
  {
    id: "00063",
    name: "tachi-aoi",
    code: "\ue95b",
  },
  {
    id: "00064",
    name: "tachibana",
    code: "\ue95c",
  },
  {
    id: "00065",
    name: "takanoha",
    code: "\ue95d",
  },
  {
    id: "00066",
    name: "takaramusubi",
    code: "\ue95e",
  },
  {
    id: "00067",
    name: "tamagaki",
    code: "\ue95f",
  },
  {
    id: "00068",
    name: "teppou-kaku",
    code: "\ue960",
  },
  {
    id: "00069",
    name: "tsuru",
    code: "\ue961",
  },
  {
    id: "00070",
    name: "tsuta",
    code: "\ue962",
  },
  {
    id: "00071",
    name: "uchi-sumuiiri-kaku",
    code: "\ue963",
  },
  {
    id: "00072",
    name: "ume",
    code: "\ue964",
  },
  {
    id: "00073",
    name: "ya",
    code: "\ue965",
  },
];
